import React, { useEffect, useState } from "react";
import { Modal, ModalDialog, Button } from "@mui/joy";
import styles from "./phoneinbound.module.css";

//지점 폰 행의 모드 pill 클릭 → 전환 확인 다이얼로그. 확인 시 부모의 onConfirm(queue, nextMode)
const ManagerModeConfirmModal : React.FC<any> = (props) => {

    const [saving, setSaving] = useState<boolean>(false);

    useEffect(() => {
        if (props.open) {
            setSaving(false);
        }
    }, [props.open]);

    const t = props.target;
    if (!t) {
        return null;
    }
    const toBranch = t.nextMode === "branch";

    const confirm = async () => {
        setSaving(true);
        const okResult = await props.onConfirm(t.queue, t.nextMode);
        setSaving(false);
        if (okResult) {
            props.onClose();
        }
    };

    return (
        <Modal open={props.open} onClose={props.onClose}>
            <ModalDialog>
                <div style={{ width: "360px" }}>
                    <div className={styles.modalTitle}>{toBranch ? "지점 직접 수신으로 전환" : "본사 담당 모드로 전환"}</div>
                    <div style={{ fontSize: "14px", lineHeight: 1.6 }}>
                        {
                            toBranch ?
                                <>
                                    <b>{t.queueName}</b> 지점을 <b>지점 직접 수신</b>으로 전환할까요?<br />
                                    지점 폰{t.phoneName ? `(${t.phoneName})` : ""}이 먼저 15초 받고, 안 받으면 본사 전원에게 넘어갑니다.<br />
                                    본사 담당자는 이 지점의 담당자 큐에서 빠집니다.
                                </>
                                :
                                <>
                                    <b>{t.queueName}</b> 지점을 <b>본사 담당 모드</b>로 되돌릴까요?<br />
                                    ★담당 지정된 본사 직원이 먼저 15초 받고, 안 받으면 전원에게 넘어갑니다.<br />
                                    지점 폰은 이 지점의 담당자 큐에서 빠집니다.
                                </>
                        }
                    </div>
                    <div className={styles.modalButtons}>
                        <Button variant="plain" color="neutral" onClick={props.onClose} disabled={saving}>취소</Button>
                        <Button variant="solid" onClick={confirm} loading={saving}>{toBranch ? "지점 직접 수신으로 전환" : "본사 담당 모드로 전환"}</Button>
                    </div>
                </div>
            </ModalDialog>
        </Modal>
    );
};

export default ManagerModeConfirmModal;
